import PropTypes from 'prop-types';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import GranteeForm from '../GranteeForm/GranteeForm.jsx';

const GranteesForm = ({
  form,
  professionalSituations,
  regimeObligatoire,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  fields,
  selectedTab,
  handleRemoveGrantee,
  minBirthDateReducChild,
  maxBirthDateReducChild,
  minBirthDateHospiChild,
  maxBirthDateHospiChild,
  offerCode,
  madelinMonths,
  middleFeatures
}) => {
  return mapIndexed(
    (field, index) => (
      <GranteeForm
        key={index}
        form={form}
        field={field}
        index={index}
        handleRemoveGrantee={handleRemoveGrantee}
        regimeObligatoire={regimeObligatoire}
        selectedTab={selectedTab}
        getMiddleText={getMiddleText}
        getMiddleBoolean={getMiddleBoolean}
        getMiddleNumber={getMiddleNumber}
        professionalSituations={professionalSituations}
        minBirthDateReducChild={minBirthDateReducChild}
        maxBirthDateReducChild={maxBirthDateReducChild}
        minBirthDateHospiChild={minBirthDateHospiChild}
        maxBirthDateHospiChild={maxBirthDateHospiChild}
        offerCode={offerCode}
        madelinMonths={madelinMonths}
        middleFeatures={middleFeatures}
      />
    ),
    fields
  );
};

GranteesForm.propTypes = {
  form: PropTypes.object,
  errors: PropTypes.object,
  regimeObligatoire: PropTypes.object,
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func,
  getMiddleNumber: PropTypes.func,
  fields: PropTypes.array,
  selectedTab: PropTypes.number,
  handleRemoveGrantee: PropTypes.func,
  minBirthDateReducChild: PropTypes.string,
  maxBirthDateReducChild: PropTypes.string,
  minBirthDateHospiChild: PropTypes.string,
  maxBirthDateHospiChild: PropTypes.string,
  offerCode: PropTypes.string,
  madelinMonths: PropTypes.array,
  middleFeatures: PropTypes.object
};

export default GranteesForm;
